import { AnbAddressSearchParameterKeys } from '@anb/ng-address-search';
import { AdfsAuthModule, AdfsConfiguration } from '@anb/ng-auth';
import { AnbNgConfiguratieService } from '@anb/ng-configuratie';
import { AnbKadasterParameterKeys } from '@anb/ng-kadaster';
import { AnbMapsUtilParameterKeys } from '@anb/ng-maps-util';
import { AnbLoaderConfig, AnbLoaderInterceptor } from '@anb/ng-ui';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule, Optional, SkipSelf } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { API_BASE_URL } from '@core/api/proxy';
import { CoreService } from '@core/services/core.service';
import { ROUTE, RouteService } from '@core/services/route.service';
import { Environment } from 'environments/environment';
import { NgxPermissionsModule } from 'ngx-permissions';
import { Clients } from './api/clients';
import { AuthConfigurationService } from './services/auth-configuration.service';

export function AuthConfig(): AdfsConfiguration {
  return {
    adfsAuthorizeUrl: Environment.adfsAuthorizeUrl,
    adfsClientId: Environment.adfsClientId,
    adfsRedirectUri: Environment.adfsRedirectUri,
    accessDeniedPath: `/${ROUTE.ERROR403}`,
    includeUrls: [Environment.API_BASE_PATH],
  };
}

const LoaderConfig: AnbLoaderConfig = {
  exclude: ['https://loc.geopunt.be/v4/suggestion?q='],
  excludeRegexp: ['/api/v1/Gemeente/gemeenteLijst'],
};

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule,
    AdfsAuthModule.forRoot(AuthConfig, AuthConfigurationService),
    NgxPermissionsModule.forRoot(),
    BrowserAnimationsModule,
  ],
  providers: [
    { provide: API_BASE_URL, useValue: Environment.API_BASE_PATH },
    {
      provide: APP_INITIALIZER,
      useFactory: (configService: AnbNgConfiguratieService) => () => {
        const result = configService
          .getConfiguration$({
            basePath: Environment.configuratieServiceUri,
            keys: [...Environment.keys, ...AnbAddressSearchParameterKeys, ...AnbKadasterParameterKeys, ...AnbMapsUtilParameterKeys],
          })
          .toPromise()
          .then(() => {
            LoaderConfig.exclude.push(
              configService.getValue('/appl/configuratieservice/geo-url/geolocation') + '/v4/suggestion?q=',
              configService.getValue('/appl/configuratieservice/referentiedata-url'),
              configService.getValue('/appl/configuratieservice/basisregister-url'));
          });
        return result;
      },
      deps: [AnbNgConfiguratieService],
      multi: true,
    },
    {
      provide: AnbLoaderConfig,
      useValue: LoaderConfig,
      deps: [AnbNgConfiguratieService],
    },
    { provide: HTTP_INTERCEPTORS, useClass: AnbLoaderInterceptor, multi: true },
    { provide: AnbLoaderConfig, useValue: LoaderConfig },
    CoreService,
    RouteService,
    ...Clients,
  ],
  exports: [AdfsAuthModule]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('Import CoreModule only in AppModule');
    }
  }
}
